// extracted by mini-css-extract-plugin
export default {"slider":"HeaderImage_slider__SByYm","vertical__slider":"HeaderImage_vertical__slider__Az9v-"};